import { NavSubItem } from '../../models/nav-sub-item';

export class UniversalVariantsNavSubItem extends NavSubItem {}
